type LosSigner = {
  representativeId?: string;
  constructionControlId?: string;
  user?: {
    userId?: string;
    surname?: string;
    firstName?: string;
    middleName?: string;
  };
};

export const getLosSignerOptionKey = (signer: LosSigner) =>
  signer.representativeId ??
  signer.constructionControlId ??
  signer.user?.userId ??
  "";

export const formatLosSignerLabel = (signer: LosSigner) => {
  const fio = [signer.user?.surname, signer.user?.firstName, signer.user?.middleName]
    .filter(Boolean)
    .join(" ");

  const role = signer.constructionControlId
    ? "Уполномоченный представитель ЛОС, по вопросам строительного контроля"
    : "Уполномоченный представитель ЛОС";

  return `${role} ${fio}`.trim();
};
